import React from 'react';
import { IconPhone, IconMail } from '@tabler/icons-react';

/**
 * VendorContactCard
 * Shared component — used by PurchasingQueuePage (Mark Ordered sheet and
 * request detail panels) and InventoryItemDetail (vendor panel, via
 * VendorItemsPanel). Not used by VendorCatalogPage.js, which maintains its
 * own separate vendor display — see Issue #22.
 *
 * Props:
 *   vendor        — inventory_vendors row (id, name, contact_name, phone, email)
 *                   or null/undefined for empty state
 *   compact       — boolean, reduces padding for tight spaces (default false)
 *   showName      — boolean, shows vendor name as header (default false)
 */
export default function VendorContactCard({ vendor, compact = false, showName = false }) {
  if (!vendor) {
    return (
      <div style={{
        background: '#F5F5F3',
        borderRadius: 8,
        padding: compact ? '8px 10px' : '10px 12px',
        fontSize: 12,
        color: '#9A9A9A',
        fontStyle: 'italic',
      }}>
        No vendor selected
      </div>
    );
  }

  const hasContact = vendor.contact_name || vendor.phone || vendor.email;

  return (
    <div style={{
      background: '#F5F5F3',
      borderRadius: 8,
      padding: compact ? '8px 10px' : '10px 12px',
      border: '1px solid #E8E8E8',
    }}>
      {showName && (
        <div style={{ fontSize: 13, fontWeight: 700, color: '#0F0F0F', marginBottom: 6 }}>
          {vendor.name}
        </div>
      )}
      {vendor.contact_name && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          marginBottom: 6,
          fontSize: 12,
          color: '#5C5C5C',
        }}>
          <span>Contact: {vendor.contact_name}</span>
        </div>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {vendor.phone ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <IconPhone size={13} color="#9A9A9A" />
            <span style={{ fontSize: 12, color: '#0F0F0F', flex: 1 }}>{vendor.phone}</span>
            <a
              href={`tel:${vendor.phone}`}
              style={{
                background: '#1D9E75',
                color: 'white',
                border: 'none',
                borderRadius: 6,
                padding: '3px 10px',
                fontSize: 11,
                fontWeight: 600,
                textDecoration: 'none',
                cursor: 'pointer',
              }}
            >
              Call
            </a>
          </div>
        ) : null}
        {vendor.email ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <IconMail size={13} color="#9A9A9A" />
            <span style={{ fontSize: 12, color: '#0F0F0F', flex: 1 }}>{vendor.email}</span>
            <a
              href={`mailto:${vendor.email}`}
              style={{
                background: 'white',
                color: '#0F0F0F',
                border: '1px solid #E0E0E0',
                borderRadius: 6,
                padding: '3px 10px',
                fontSize: 11,
                fontWeight: 600,
                textDecoration: 'none',
                cursor: 'pointer',
              }}
            >
              Email
            </a>
          </div>
        ) : null}
        {!hasContact && (
          <div style={{ fontSize: 11, color: '#9A9A9A', fontStyle: 'italic' }}>
            No contact info on file
          </div>
        )}
      </div>
    </div>
  );
}
